import axios from 'axios';

// Create an Axios instance
const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000',
    timeout: 120000, // 2 minutes to handle larger operations / database exports
    headers: {
        'Accept': 'application/json, text/plain, */*'
    }
});

// Request Interceptor: Attach Admin Token for secure endpoints
api.interceptors.request.use(
    (config) => {
        const adminToken = localStorage.getItem('admin');
        if (adminToken) {
            config.headers['Authorization'] = `Bearer ${adminToken}`;
            config.headers['auth-token'] = adminToken;
            config.headers['x-admin-token'] = adminToken;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response Interceptor
api.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.response && error.response.status === 401) {
            console.error('Unauthorized! Admin token may have expired.');
            localStorage.removeItem('admin');
            if (window.location.pathname !== '/') {
                window.location.href = '/';
            }
        }
        return Promise.reject(error);
    }
);

export default api;
